import { combineReducers } from 'redux'
import { REDUCER_NAME } from './const'
import { reducer as basisReducer, REDUCER_NAME as BASIS_REDUCER_NAME } from './basis'
import { reducer as funnelReducer, REDUCER_NAME as FUNNEL_REDUCER } from './funnel-builder'
import { reducer as stateResponsibleReducer, REDUCER_NAME as STATE_RESPONSIBLE_REDUCER } from './state-responsible'
import { reducer as transitionReducer, REDUCER_NAME as TRANSITION_REDUCER } from './transition'


const reducer = combineReducers({
    [BASIS_REDUCER_NAME]: basisReducer,
    [FUNNEL_REDUCER]: funnelReducer,
    [STATE_RESPONSIBLE_REDUCER]: stateResponsibleReducer,
    [TRANSITION_REDUCER]: transitionReducer,
})

export {
    reducer,
    REDUCER_NAME,
}



// WEBPACK FOOTER //
// ./src/modules/analytics/state/index.js